<form (ngSubmit)="formSubmit.next(formGroup.value)" [formGroup]="formGroup">
  <ng-container *ngFor="let field of fields" [ngSwitch]="field.type">
    <rav-textarea
      *ngSwitchCase="'textarea'"
      [controlFormGroup]="formGroup"
      [controlName]="field.name"
      [height]="field.height"
    ></rav-textarea>
    <rav-select
      *ngSwitchCase="'select'"
      [controlFormGroup]="formGroup"
      [controlName]="field.name"
      [selectOptions]="field.selectOptions"
    ></rav-select>
    <ng-container *ngSwitchDefault>
      <ng-container *ngIf="isPasswordField(field.name)">
        <rav-input
          [controlFormGroup]="formGroup"
          [controlName]="field.name"
          [isPassword]="true"
          [(isPasswordVisible)]="isPasswordVisible"
          [dataCy]="'input-' + field.name"
        ></rav-input>
        <rav-password
          class="password-strength-theme"
          *ngIf="field.hasPasswordMeter"
          [form]="formGroup"
          [pwValue]="formGroup.value[field.name]"
        ></rav-password>
      </ng-container>
      <ng-container *ngIf="!isPasswordField(field.name)">
        <rav-input
          [controlFormGroup]="formGroup"
          [controlName]="field.name"
          [dataCy]="'input-' + field.name"
        ></rav-input>
      </ng-container>
    </ng-container>
  </ng-container>

  <ng-content></ng-content>

  <div *ngIf="successMessage" class="small callout success">{{ successMessage }}</div>
  <rav-form-messages [formGroup]="formGroup"></rav-form-messages>

  <button
    *ngIf="hasSubmit"
    type="submit"
    class="button"
    [class.secondary]="!hasCancel"
    [class.expanded]="!hasCancel"
    [disabled]="isButtonDisabled || formGroup.invalid || isSubmitting"
    data-cy="submit-form-button"
  >
    <div class="grid-x">
      <div *ngIf="isSubmitting" class="cell shrink margin-right-1"><i class="fa fa-spinner fa-spin"></i></div>
      <div class="cell auto">{{ buttonText }}</div>
    </div>
  </button>

  <button
    *ngIf="hasCancel"
    type="button"
    (click)="cancel.emit()"
    class="button hollow margin-left-1"
    data-cy="cancel-form-button"
  >
    Cancel
  </button>
</form>
